<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import LoadingSpinnerIcon from '@shared/component/LoadingSpinnerIcon/LoadingSpinnerIcon.vue';
import type { ItemLinkProps } from './types';

const props = defineProps<ItemLinkProps>();
</script>

<template>
  <a
    v-bind="props.menuRouterBindProps.action"
    class="gap-2"
    :href="props.menuItem.url"
    :target="props.menuItem.target"
  >
    <LoadingSpinnerIcon v-if="props.menuItem.loading" fixed-width />

    <FontAwesomeIcon v-else-if="props.menuItem.icon" fixed-width :icon="props.menuItem.icon" />

    <span v-bind="props.menuRouterBindProps.label">{{ props.menuItem.label }}</span>
  </a>
</template>
